import { vehiclesApi } from '@repo/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useTranslation } from 'react-i18next'
import { toast } from 'sonner'

import { getApiErrorMessage } from '@/lib/api/get-api-error-message'

export const useDeleteVehicle = () => {
  const queryClient = useQueryClient()
  const { t } = useTranslation(['vehicles', 'common'])

  return useMutation({
    mutationKey: ['deleteVehicle'],
    mutationFn: (vehicleId: number) => {
      return vehiclesApi.deleteVehicle(vehicleId)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['vehicles'] })
      toast.success(t('vehicles:toasts.deletedSuccess'))
    },
    onError: (error: Error) => {
      toast.error(
        getApiErrorMessage(error, t, t('vehicles:toasts.deletedError')),
      )
    },
  })
}
